
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 78.82 50.95"}, attrs),
              ...rest,
            },
            children.concat([_c('title',[_v('laptop')]),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M8.13,41.68V4.49A4.16,4.16,0,0,1,12.56,0h54a4.18,4.18,0,0,1,4.14,3.9c0,.2,0,.4,0,.6V41.68Zm4.54-4.58H66.09V4.56H12.67Z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M49.18,44.11H78.82a6.91,6.91,0,0,1-6.93,6.83q-32.52,0-65,0A6.89,6.89,0,0,1,0,44.81c0-.22,0-.44,0-.69h29.6c.08.25.14.53.25.79a2.24,2.24,0,0,0,2.26,1.43H46.43A2.4,2.4,0,0,0,49.18,44.11Z"}})])])])
          )
        }
      }
    